import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Led.module.scss";

export const GreenLed = ({ Children }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={`${styles.led_box} ${styles.tag_green}`}>
        <p>{t("team.authorized")}</p>
        <span>{Children}</span>
      </div>
    </div>
  );
};

export const RedLed = ({ Children }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={`${styles.led_box} ${styles.tag_red}`}>
        <p>{t("team.not_authorized")}</p>
        <span>{Children}</span>
      </div>
    </div>
  );
};

export const YellowLed = ({ Children }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={`${styles.led_box} ${styles.tag_yellow}`}>
        <p>{t("team.authorized")}</p>
        <span>{Children}</span>
      </div>
    </div>
  );
};

//ONLY LED WITHOUT CONTAINER — tag style indicators
export const GreenLedSolo = ({ height, width, margin, label }) => {
  if (label) return <span className={`${styles.tag} ${styles.tag_green}`}>{label}</span>;
  return (
    <div className={styles.led_box_solo}>
      <div className={styles.led_green} style={{ width, height, margin }}></div>
    </div>
  );
};

export const RedLedSolo = ({ height, width, margin, label }) => {
  if (label) return <span className={`${styles.tag} ${styles.tag_red}`}>{label}</span>;
  return (
    <div className={styles.led_box_solo}>
      <div className={styles.led_red} style={{ width, height, margin }}></div>
    </div>
  );
};

export const YellowLedSolo = ({ height, width, margin, label }) => {
  if (label) return <span className={`${styles.tag} ${styles.tag_yellow}`}>{label}</span>;
  return (
    <div className={styles.led_box_solo}>
      <div className={styles.led_yellow} style={{ width, height, margin }}></div>
    </div>
  );
};

export const BlueLedSolo = ({ height, width, margin, label }) => {
  if (label) return <span className={`${styles.tag} ${styles.tag_blue}`}>{label}</span>;
  return (
    <div className={styles.led_box_solo}>
      <div className={styles.led_blue} style={{ width, height, margin }}></div>
    </div>
  );
};
